import { SelectField } from '@flos/react-ui';
import { type DeductibleOptionDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto';
import { useHippoText } from '../../../../hooks/useHippoText';
import CoveragePackageModalLink from '../CoveragePackageModalLink';
import type { SetStateAction, ChangeEvent } from 'react';
import { useSetRecoilState } from 'recoil';
import { refreshCoveragePackagePricesAtom } from '../../../../recoil/atoms/refreshCoveragePackagePricesAtom';
import { useUpdateCoverableInformation } from '../../../../recoil/hooks/useUpdateCoverableInformation';

const CoveragePackageUvpInputs = ({
    isLoading,
    setIsLoading,
    deductibleOptions,
    deductible,
    setDeductible,
    updateCoveragePackageInformation
}: {
    isLoading: boolean;
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
    deductibleOptions: DeductibleOptionDTO[];
    deductible: string | undefined;
    setDeductible: React.Dispatch<SetStateAction<string | undefined>>;
    updateCoveragePackageInformation: (objectToUpdate: object) => Promise<void>;
}): React.JSX.Element => {
    const getHippoText = useHippoText();
    const modalName = getHippoText('DSS-COVERAGE-PACKAGE-PAGE-INPUT-INFO');
    const { updateCoverableInformation } = useUpdateCoverableInformation();
    const refreshPrices = useSetRecoilState(refreshCoveragePackagePricesAtom);

    const changeDeductible = (event: ChangeEvent<HTMLSelectElement>): void => {
        const deductible = event.target.value;
        setIsLoading(true);
        setDeductible(deductible);
        const option = deductibleOptions.find((option) => option.optionID === deductible);
        if (!option) {
            setIsLoading(false);
            return;
        }
        updateCoverableInformation({ deductible: option.optionID });
        void updateCoveragePackageInformation({ deductible: option.optionID }).then(() => {
            refreshPrices({});
            setIsLoading(false);
        });
    };

    return (
        <div className="u-spacing-inset-m--stretch-max">
            <div className="u-flex-box u-flex-box--space-between">
                <h4 className="u-spacing-stack-none">
                    {getHippoText('DSS-COVERAGE-PACKAGE-PAGE-DEDUCTIBLE-HEADER')}
                </h4>
                <CoveragePackageModalLink
                    modalName={modalName}
                    title={getHippoText('DSS-INFO-MODAL-UVPLOB-DEDUCTIBLE-TITLE')}
                    description={getHippoText('DSS-INFO-MODAL-UVPLOB-DEDUCTIBLE-BODY')}
                />
            </div>
            <div>
                <SelectField
                    onChange={changeDeductible}
                    label={getHippoText('DSS-COVERAGE-PACKAGE-PAGE-DEDUCTIBLE-INFO-MODAL-TITLE')}
                    options={deductibleOptions.map((option) => {
                        return { label: option.displayName, value: option.optionID };
                    })}
                    value={deductible}
                    disabled={isLoading}
                ></SelectField>
            </div>
        </div>
    );
};

export default CoveragePackageUvpInputs;
